import React from 'react';
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLaptopCode, faBriefcase, faProjectDiagram, faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Navbar({ scrollToSection }) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const goToPage = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleScrollToSection = (scrollFunction) => {
    scrollFunction();
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const name = "<Seema/>";

  return (
    <>
      <div className="nav_container">
        <div className="mt-2 lg:text-5xl text-4xl sm:text-4xl text-transparent font-bold bg-clip-text bg-gradient-to-r from-primary-400 to-secondary-600 mb-0 " data-text={name}>{name}</div>
        <button className="navbar-toggler" onClick={toggleMenu}>
          <span className="navbar-toggler-icon">&#9776;</span>
        </button>
        <div className={`nav_right ${isMenuOpen ? "show" : ""}`}>
          <p onClick={() => handleScrollToSection(scrollToSection.about)}><FontAwesomeIcon icon={faUser} /> About</p>
          <p onClick={() => handleScrollToSection(scrollToSection.techStack)}><FontAwesomeIcon icon={faLaptopCode} /> Tech Stack</p>
          <p onClick={() => handleScrollToSection(scrollToSection.experience)}><FontAwesomeIcon icon={faBriefcase} /> Experience</p>
          <p onClick={() => handleScrollToSection(scrollToSection.projects)}><FontAwesomeIcon icon={faProjectDiagram} /> Projects</p>
          <p onClick={() => handleScrollToSection(scrollToSection.footer)}><FontAwesomeIcon icon={faEnvelope} /> Contacts</p>
        </div>
      </div>
    </>
  );
}

export default Navbar;
